<div class="rx-card">
	<div class="rx-card-title">
		<div class="rx-title-row" fxLayout="row" fxLayoutAlign="start center">
			<div>{{ 'DentureDetails.SectionTitle' | translate }}:</div>
		</div>
	</div>
	<form class="rx-card-body" [formGroup]="form" fxLayout="row" fxLayoutAlign="space-between">
		<div fxLayout="column" fxLayoutAlign="stretch stretch" fxFlex="0 1 calc(50% - 15px)">
			<rx-select
				[id]="'stage'"
				[label]="'DentureDetails.StageTitle' | translate"
				[formControl]="stageControl"
				[options]="stages$ | async"
				[isDisabled]="(isReadOnly$ | async)"
				[isCancellable]="true"
				(disableChangeEvent)="cleanControlWhenDisabled($event, stageControl)"
				name="stageControl"
			>
			</rx-select>

			<rx-moulds-dropdown
				[id]="'mould'"
				[label]="'DentureDetails.MouldTitle' | translate"
				[formControl]="mouldControl"
				[options]="moulds$ | async"
				[isReadOnly]="isReadOnly$ | async"
				[isCancellable]="true"
				name="mouldControl"
			>
			</rx-moulds-dropdown>

			<div fxLayout="column" fxLayoutAlign="center" fxFlex="33%">
				<div fxLayout="row" class="sides" fxLayoutAlign=" end" fxFlex="70%">
					<label>{{ 'DentureDetails.UpperDentureTitle' | translate }}</label>
					<mat-slide-toggle
						fxFlex="50%"
						color="primary"
						[formControl]="isUpperControl"
						name="isUpperControl"
						[id]="'isUpper'"
						labelPosition="before"
						[rxIsDisabled]="(dentureUpperSectionIsReadonly$ | async) || (isReadOnly$ | async)"
					></mat-slide-toggle>
					<label>{{ 'DentureDetails.LowerDentureTitle' | translate }}</label>
					<mat-slide-toggle
						fxFlex="50%"
						color="primary"
						[formControl]="isLowerControl"
						name="isLowerControl"
						[id]="'isLower'"
						labelPosition="before"
						[rxIsDisabled]="(dentureLowerSectionIsReadonly$ | async) || (isReadOnly$ | async)"
					></mat-slide-toggle>
				</div>
				<mat-divider></mat-divider>
			</div>
		</div>
		<div fxLayout="column" fxLayoutAlign="stretch stretch" fxFlex="0 1 calc(50% - 15px)">
			<rx-select
				fxFlex="33%"
				[id]="'shadeSystem'"
				[label]="'DentureDetails.ShadeSystemTitle' | translate"
				[formControl]="shadeSystemControl"
				[options]="shadeSystems"
				[isDisabled]="isReadOnly$ | async"
				[isCancellable]="false"
				[isRequired]="(shouldValidateForSend$ | async)"
				name="shadeSystemControl"
			>
			</rx-select>
			<rx-string-selector
				*ngIf="teethShadesHasOptions$ | async"
				[id]="'teethShade'"
				[label]="'DentureDetails.TeethShadeTitle' | translate"
				[formControl]="teethShadeControl"
				[options]="teethShades$ | async"
				name="teethShadeControl"
				[isDisabled]="!isTeethShadeEnabled"
				[isReadOnly]="isReadOnly$ | async"
				[isCancellable]="true"
				[isRequired]="(shouldValidateForSend$ | async)"
			>
			</rx-string-selector>
			<mat-form-field
				*ngIf="!(teethShadesHasOptions$ | async)"
				[class.disabled]="!isTeethShadeEnabled"
				[class.read-only]="isReadOnly$ | async"
			>
				<mat-label>{{ 'DentureDetails.TeethShadeTitle' | translate }}</mat-label>
				<input matInput maxlength="10" [formControl]="teethShadeControl" autocomplete="off"
					   name="teethShadeControl" />
			</mat-form-field>
			<rx-select
				[id]="'gingivalShade'"
				[label]="'DentureDetails.GingivalShadeTitle' | translate"
				[formControl]="gingivalShadeControl"
				[options]="gingivalShades$ | async"
				[isDisabled]="isReadOnly$ | async"
				[isCancellable]="true"
				[isRequired]="(shouldValidateForSend$ | async)"
				name="gingivalShadeControl"
			>
			</rx-select>
		</div>
	</form>
</div>
